/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

const styles = {
  team: (props) => ({
    display: 'flex',
    alignItems: 'center',
    margin: '3px 0',
    flexDirection: props.reverse ? 'row-reverse' : 'row',
    opacity: !props.pick.teamId || props.team.id === props.pick.teamId ? '1' : '0.2',
    justifyContent: props.justifyflexcontent,
    padding: '5px',
    // border: '1px solid #ededed',
    borderRadius: '20px',
    gap: '5px',
  }),
  radio: (props) => ({
    background: props.team.id && props.team.id === props.pick.teamId ? props.color
      : `url(assets/images/flags/${props.team.id}.svg)`,
    width: '20px',
    height: '20px',
    border: '1px solid',
    borderColor: props.team.id === props.pick.teamId ? props.color : 'lightgray',

    borderRadius: '100%',
    // marginRight: props.reverse ? '0' : '12px',
    // marginLeft: props.reverse ? '12px' : '0',
    cursor: props.team.id ? 'pointer' : 'unset',
    fontSize: '10px',
    color: 'white',
    paddingTop: '1px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  }),
  check: (props) => ({
    display: props.team.id && props.team.id === props.pick.teamId ? 'block' : 'none',
  }),
  name: (props) => ({
    color: props.team.name ? props.color : 'lightgray',
    cursor: props.team.id ? 'pointer' : 'default',
    display: 'flex',
    flexDirection: props.reverse ? 'row-reverse' : 'row',
    whiteSpace: 'nowrap',
  }),
  img: (props) => ({
    width: '20px',
    height: '20px',
    margin: props.reverse ? '0 0 0 5px' : '0 5px 0 0',
  }),
};

const Team = ({
  classes,
  team,
  pick,
  placeholder,
  onPick,
}) => (
  <div className={classes.team}>
    <div className={`teamradio ${classes.radio}`} onClick={() => onPick(pick, team.id || null)}>
      <i className={`fas fa-check ${classes.check}`} />
    </div>
    <div className={classes.name}>
      {/* <img className={classes.img} src={`assets/flags/${team.id}.svg`} alt={team.name} /> */}
      {team.name ? team.name : placeholder}
    </div>
  </div>
);

Team.propTypes = {
  classes: PropTypes.object.isRequired,
  team: PropTypes.object.isRequired,
  pick: PropTypes.object.isRequired,
  placeholder: PropTypes.string.isRequired,
  onPick: PropTypes.func.isRequired,
};

export default injectSheet(styles)(Team);
